import type { PropsWithChildren } from 'react';
import { useEffect, useMemo } from 'react';
import { setUser } from '@sentry/react';

import { useAuth } from '@izimi/auth';
import { TrackingProvider } from '@izimi/components';
import type { Tracking } from '@izimi/core';
import { useModules } from '@izimi/modules';
import config from 'core/config';
import { useConfigurationLinks } from 'core/modules/public';

export const NotaryTrackingProvider = ({ children }: PropsWithChildren) => {
  const { cookieUrl } = useConfigurationLinks();
  const { user } = useAuth();
  const {
    public: { useNotaryConfiguration },
  } = useModules();
  const { configuration } = useNotaryConfiguration();

  const userId = useMemo(() => user?.profile.id, [user?.profile.id]);

  useEffect(() => {
    if (userId) {
      setUser({ id: userId });
    }
  }, [userId]);

  const tracking = useMemo<Tracking | null>(
    () =>
      configuration?.analytics
        ? {
            siteId: configuration.analytics.id,
            url: config.apiUrl,
            trackerUrl: configuration.analytics.trackerUrl,
            srcUrl: configuration.analytics.srcUrl,
            userId,
          }
        : null,
    [configuration, userId],
  );

  return (
    <TrackingProvider config={tracking} cookieUrl={cookieUrl}>
      {children}
    </TrackingProvider>
  );
};
